<div *ngIf="_gearService?.GearMonitorLiterals && _appService?.CoreCommonLiterals">
  <div class="container-fluid p-0">
    <div class="page-title my-4 my-sm-0">
      <div class="row align-items-center justify-content-between">
        <div class="col-sm-6 mb-sm-0 mb-2">{{_appService?.CoreCommonLiterals.IncidentMap_Title | replaceLiterals:[generalLiteral]}}</div>
      </div>
    </div>
    <div class="flex-container">
      <div class="screen-container flex-item-left" #firstElement>
        <agm-map #agmMap [fitBounds]="bounds" [maxZoom]="commonMapService.MaxZoom" [styles]="commonMapService.StylesIncidents"
        (mapReady)="onMapReady($event)" (mapClick)="mapClicked($event)" [latitude]="_latitudeCenter" [longitude]="_longitudeCenter" [zoom]="_zoom" (centerChange)="onCenterChange($event)"
        (zoomChange)="onZoomChange($event)" (boundsChange)="boundsChange($event)">
          <agm-map-type-control></agm-map-type-control>
          <ng-container *ngIf="mapReady">
            <agm-polygon [clickable]="false" *ngFor="let pm of _pathsMaintenanceContractors" [paths]="pm.paths" [fillColor]="pm.fillColor"
            [fillOpacity]="pm.fillOpacity" [strokeColor]="pm.borderColor" [strokeOpacity]="pm.borderOpacity" [strokeWeight]="pm.borderWidth">
          </agm-polygon>
          <agm-polygon [clickable]="false" *ngFor="let pm of _pathsUtilityCompanies" [paths]="pm.paths" [fillColor]="pm.fillColor"
            [fillOpacity]="pm.fillOpacity" [strokeColor]="pm.borderColor" [strokeOpacity]="pm.borderOpacity" [strokeWeight]="pm.borderWidth">
          </agm-polygon>
          <agm-marker *ngFor="let m of clustersFilteredList"
            [latitude]="m.markerData.latitude"
            [longitude]="m.markerData.longitude"
            [iconUrl]="m.markerData.url"
            (markerClick)="onMarkerClick(m.markerData)"
            (markerRightClick)="onRightClick(m.markerData)"
            (mouseOver)="_activeMarker = m.incidentData.IncidentID ? m.incidentData.IncidentID : m.incidentData.FacilityID"
            (mouseOut)="_activeMarker = 0">
            <agm-info-window   [disableAutoPan]="false" [isOpen]="((m.incidentData.IncidentID && m.incidentData.IncidentID == _activeMarker) || (m.incidentData.FacilityID && m.incidentData.FacilityID == _activeMarker))">
              <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(m.markerData.html)"></div>
            </agm-info-window>
          </agm-marker>
          </ng-container>
        </agm-map>
        <button class="btn btn-secondary floating-button" [ngClass]="{'collapsibleOpen': _appService.sidebarIsOpen()}">
          <i class="fa-solid fa-layer-group fa-lg"></i>
        </button>
      </div>
      <lib-collapsible-sidebar #collapsibleSidebar
      [firstResizeElement]="firstElement"
      [activeItem]="activeContent"
      (activeContent)="openSidebar($event);"
      [sidebarItems]="sidebarItems"
      [sidebarWidth]="sidebarWidth"
      (onScrollEvent)="onScrollEvent($event)"
      (onClose)="sidebarClose($event)"
      [title]="activeTitle">
        <div *ngIf="activeContent === 23">
          <app-incident-form 
          #incidentForm
          [incidentID]="incidentID" 
          (newMarker)="addNewMarker($event)"
          (cleanSearch)="onClickclearText()"
          (cleanMarker)="cleanMarker($event)"
          (onCenterMap)="centerMap($event)"
          (confirmExitRoute)="$event?.OnConfirmExitRoute ? onConfirmChangeTab($event?.OnConfirmExitRoute) : exitEditing($event?.ExitEditing) "
          ></app-incident-form>
        </div>
        <div class="form-group"  [ngClass]="{'d-none': activeContent !== 24}">
          <form autocomplete="off">
            <div class="form-group col-12">
              <form-parameters #formParam [context]="this" [formParameterList]="formParameterList" (click)="_errorBackEnd= ''" (formParameterChange)="emitChangeParam($event)" [ngClass]="{'disabled-form': !enableFilter}"></form-parameters>
              <div class="text-right mt-5">
                <button (click)="applyIncidentFilters('apply');" type="submit" id="btn-apply-filters" class="btn btn-primary btn-block mt-3">
                  <span *ngIf="loaderFilter != 1 && status !== 0">{{_appService.CoreCommonLiterals?.Apply}}</span>
                  <span class="loader-spiner text-center align-content-center" *ngIf="loaderFilter == 1">
                    <i class="fas fa-circle-notch fa-spin fa-lg"></i>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <div class="alert alert-danger my-2" *ngIf="_errorBackEnd">{{_errorBackEnd}}</div>
        </div>
        <div class="form-group" *ngIf="activeContent === 25">
          <lib-communications-chat></lib-communications-chat>
        </div>
      </lib-collapsible-sidebar>

      <div  id="menuAddIncident" class="dropdown-menu">
        <li role="menuitem" class="item d-flex align-items-center" dropdown id="drop-menuitem" #dropdown="bs-dropdown" style="z-index: 100">
          <button type="button" id="pulse-button" class="dropdown-item px-2" (click)="createIncident()" *ngIf="!_incidentID">
            <i class="fas fa-plus"></i> Crear evento
          </button>
          <button type="button" id="pulse-button" class="dropdown-item px-2" (click)="editIncident()" *ngIf="_incidentID">
            <i class="fa-solid fa-pen-to-square"></i> Editar evento
          </button>
        </li>
      </div>
    </div>
  </div>
</div>
<modal #detailModal
  id="detailModal"
  [(successMessage)]="_successMessage"
  [(errorMessage)]="_errorMessage"
  *ngIf="_appService && _appService.CoreCommonLiterals !== undefined"
  modalClass="modal-xl"
>
<modal-header>{{_appService.CoreCommonLiterals.Details}}</modal-header>
<modal-content>
  <ul class="nav nav-tabs">
    <li class="nav-item" id="map-tab-{{i}}" *ngFor="let b of _deviceModalTextAttributes;let i=index;" (click)="activeModalTab = i">
      <a type="button" class="nav-link" [class.active]="(activeModalTab === i)">{{b.Description}}</a>
    </li>
  </ul>
  <div *ngFor="let b of _deviceModalTextAttributes;let i=index;">
    <div class="table-responsive" *ngIf="activeModalTab === i">
      <table class="table table-condensed table-bordered table-striped">
        <tbody>
          <tr *ngFor="let t of b.TextAttributes">
            <td>
              {{t.Name}}
              <i *ngIf="t.IconType ===  1" class="fa fa-info-circle" style="color: blue; text-align: right; float: right;"></i>
              <i *ngIf="t.IconType ===  2" class="fa fa-exclamation-triangle" style="color: yellow; text-align: right; float: right;"></i>
              <i *ngIf="t.IconType ===  3" class="fa fa-exclamation-circle" style="color: red; text-align: right; float: right;"></i>
            </td>
            <td *ngIf="t.Value">
              {{t.Value}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</modal-content>
<modal-footer>
  <a id="map-btn-close" class="btn btn-primary" (click)="detailModal.close()">{{_appService.CoreCommonLiterals.ButtonClose}}</a>
</modal-footer>
</modal>